export default __webpack_public_path__ + "820c86bbb5c2ae16bcf580bda6d7b4df.jpeg";